import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ProgressIndicator } from '@veneer/core';
import { getUrlParams, setUrlParams } from '../../helpers/useInputParameters';
import { LocalStorageHelper } from '../../helpers/localStorage';

const HomePage = () => {
  const history = useHistory();
  const router = { location: useLocation() };

  const urlParams = useMemo(() => {
    return {
      both: getUrlParams(new URLSearchParams(window.location.search), new URLSearchParams(router.location.search)),
      hash: getUrlParams(new URLSearchParams(router.location.search)),
    };
  }, [router.location.search]);

  const handleRedirectToDesigner = () => {
    // Its a new user (no projectId on params), redirecting to /designer ValueProp page
    if (!urlParams.both.projectId) return history.replace('/designer');

    history.replace(`/designer${setUrlParams(urlParams.hash) ?? ''}`);
  };

  // Remove last page feature to make working around page load bugs easier.
  //
  // const handleLastPageRedirect = () => {
  //   const lastPage = LocalStorageHelper.getLastPage();

  //   // Its a new user (no projectId on params), redirecting to /designer ValueProp page
  //   if (!urlParams.both.projectId) return history.replace('/designer');

  //   // Its a PSF checkout lastPage, redirecting to the PSF url
  //   if (lastPage === 'psf') {
  //     const psfUrl = LocalStorageHelper.getPsfUrl();
  //     if (!psfUrl || psfUrl === '') {
  //       return history.replace(`/cart${setUrlParams(urlParams.hash) ?? ''}`);
  //     }
  //     console.log('Redirecting to PSF checkout URL:', psfUrl);
  //     WindowLocationHelper.href(psfUrl);
  //     return;
  //   }

  //   // Its a resume user (projectId on params), redirecting to last page or /designer +
  //   // URL params only from the hash side, because the query side params are always set
  //   history.replace(`/${lastPage || 'designer'}${setUrlParams(urlParams.hash) ?? ''}`);
  // };

  useEffect(() => {
    // Disable last page to allow for resumes to always hit the Resume Interstitial where we can
    // reset the project.
    // handleLastPageRedirect();
    handleRedirectToDesigner();
  }, [history]);

  return (
    <div className="spinner">
      <ProgressIndicator />
    </div>
  );
};

export default HomePage;
